import { useTranslation } from 'react-i18next'
import { i18n } from '@fs/zion-locale'
import { useFeatureFlag } from '@fs/zion-flags'
import { geoData } from '@fs/zion-config'
import langUrlMap from './familyTreeLangUrlMap.json'

export default function useOfferLinks({ nonReligiousMode, isCoreLanguage, canAddPersonalData }) {
  const { t } = useTranslation()
  const { isOn: useFamilyTreeUrl } = useFeatureFlag('tree-overview_useFamilyTreeUrl')

  const isSpanishOrPortuguese = i18n.language === 'es' || i18n.language === 'pt'
  const isLatinAmerica = [
    'MX',
    'BZ',
    'CR',
    'SV',
    'GT',
    'HN',
    'NI',
    'PA',
    'AG',
    'BS',
    'BB',
    'CU',
    'DM',
    'DO',
    'GD',
    'HT',
    'JM',
    'KN',
    'LC',
    'MF',
    'PR',
    'VC',
    'TT',
    'AR',
    'BO',
    'BR',
    'CL',
    'CO',
    'EC',
    'GY',
    'PY',
    'PE',
    'SR',
    'UY',
    'VE',
  ].includes(geoData?.country)

  return {
    id: 'offer',
    title: t('nav.offer', 'What We Offer'),
    subNav: [
      {
        id: 'tree',
        text:
          isLatinAmerica && isSpanishOrPortuguese
            ? t('feedback.category.genealogical-tree', 'Genealogical Tree')
            : t('feedback.category.family-tree', 'Family Tree'),
        url: useFamilyTreeUrl ? `/${i18n.language}${langUrlMap[i18n.language] || '/family-tree/'}` : '/tree/overview',
        linkName: 'ff_offer_tree',
        dataTestId: 'ff_family_tree',
        isNew: false,
      },
      {
        id: 'records',
        text: t('nav.links.offer.records', 'Genealogy Records'),
        url: '/search/',
        linkName: 'ff_offer_records',
        dataTestId: 'ff_gen_records',
        isNew: false,
      },
      {
        id: 'sharing',
        text: t('nav.links.offer.sharing', 'Family Photo Sharing'),
        url: '/memories/',
        linkName: 'ff_offer_sharing',
        dataTestId: 'ff_photo_sharing',
        isNew: false,
        hidden: !canAddPersonalData,
      },
      {
        id: 'activities',
        text: t('nav.links.offer.activities', 'Family Activities'),
        url: '/discovery/',
        linkName: 'ff_offer_activities',
        dataTestId: 'ff_family_activities',
        isNew: false,
        hidden: !isCoreLanguage,
      },
      {
        id: 'learnRes',
        text: t('nav.links.offer.learnRes', 'Learning Resources'),
        url: `/${i18n.language}/help/helpcenter/landing`,
        linkName: 'ff_offer_learnRes',
        dataTestId: 'ff_learnRes',
        isNew: false,
      },
      {
        id: 'reGuide',
        text: t('nav.links.offer.reGuide', 'Research Guidance'),
        url: '/help/helpcenter/one-on-one',
        linkName: 'ff_offer_reGuide',
        dataTestId: 'ff_resGuide',
        isNew: false,
        hidden: nonReligiousMode,
      },
      {
        id: 'dnaEd',
        text: t('nav.links.offer.dnaEd', 'DNA Education'),
        url: `/${i18n.language}/dna-testing/`,
        linkName: 'ff_offer_dnaEd',
        dataTestId: 'ff_dnaEd',
        isNew: false,
        hidden: !isCoreLanguage || !canAddPersonalData,
      },
      {
        id: 'surname',
        text: t('nav.links.offer.surname', 'Surname Meanings'),
        url: `/${i18n.language}/surname`,
        linkName: 'ff_offer_surname',
        dataTestId: 'ff_surname_meanings',
        isNew: false,
      },
    ],
  }
}
